<template>
  <div class="base-container">
    <div class="admin-container">
      <v-card class="pa-3 ma-3 flex d-flex flex-column card-container" max-width="1200px" min-width="1200px" elevation="5">
        <div class="admin-text">Results</div>
        <div class="selection-container">
          <v-select :loading="loading" label="Simulation Name" :items="getSimulationNames()" v-model="localSelected" @input="newSelection"> </v-select>
          <div class="settings-icon">
            <ResultSettings @updateOptions="updateOptions" />
          </div>
        </div>
        <div v-show="showManual($store.state.adminPanel.selected)">
          <ManualResults ref="manual" />
        </div>

        <div v-show="showAutomated($store.state.adminPanel.selected)">
          <AutomaticResults ref="auto" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { NetworkHandler } from "@/pipeline/networkHandler.js";
import AutomaticResults from "@/components/AdminResults/AutomaticResults.vue";
import ManualResults from "@/components/AdminResults/ManualResults.vue";
import ResultSettings from "@/components/AdminResults/ResultSettings.vue";

export default {
  name: "Home",
  components: { AutomaticResults, ManualResults, ResultSettings },
  async mounted() {
    if (this.$store.state.adminPanel.selected == null) {
      this.$store.state.adminPanel.selected = this.$store.state.Simulations[0].Simulation_Name;
    }
    this.$store.state.comps.admin = this;

    this.localSelected = this.$store.state.adminPanel.selected;

    this.updateTable();

    if (this.$store.state.adminPanel.requestUpdateID != null) {
      clearInterval(this.$store.state.adminPanel.requestUpdateID);
    }
    this.$store.state.adminPanel.requestUpdateID = setInterval(this.requestUpdate, 1000);
  },
  data() {
    return {
      data: [],
      loading: false,
      localSelected: 0,
      latestOptions: {
        option: "today",
        date: new Date(),
      },
    };
  },
  methods: {
    async newSelection() {
      this.loading = true;
      await this.updateTable();
      this.loading = false;
      this.$store.state.adminPanel.selected = this.localSelected;
    },
    updateOptions(newOptions) {
      if (newOptions == this.latestOptions) {
        return;
      }

      this.latestOptions = newOptions;

      var currTable = this.getCurrentTable();
      if (currTable == null) {
        return;
      }

      currTable.loading = true;
      this.updateTable();
    },
    //Filter the data by the given date in the options
    filterData(data) {
      var options = this.latestOptions;
      var predicate = (element) => {
        return true;
      };
      //Get all results with the date in the last 24 hours
      if (options.option == "today") {
        predicate = (element) => {
          var oneDay = new Date().getTime() - 24 * 60 * 60 * 1000;
          return new Date(element.createdAt).getTime() > oneDay;
        };
      }

      if (options.option == "date") {
        predicate = (element) => {
          return new Date(element.createdAt).toISOString().slice(0, 10) == new Date(options.date).toISOString().slice(0, 10);
        };
      }

      return data.filter(predicate);
    },
    showManual(selected) {
      if (selected == 0 || selected == null) return false;
      return this.$store.getters.getSimulationFromName(selected).Sim_Type == "Manual";
    },
    showAutomated(selected) {
      if (selected == 0 || selected == null) return false;
      return this.$store.getters.getSimulationFromName(selected).Sim_Type == "Automatic";
    },

    async requestUpdate() {
      if (this.$router.currentRoute.path != "/admin") {
        return;
      }

      var newCount = await this.$store.state.networkHandler.getResultsCount(this.$store.state.adminPanel.selected);

      if (newCount == -1) {
          clearInterval(this.$store.state.adminPanel.requestUpdateID);
          this.$store.state.adminPanel.requestUpdateID = null;
          return;
      }
      if (newCount != this.data.length) {
        this.updateTable();
      }
    },

    getCurrentTable() {
      var currTable = this.$refs.manual;

      if (this.showAutomated(this.localSelected)) {
        currTable = this.$refs.auto;
      }

      return currTable;
    },

    async updateTable() {
      if (this.localSelected == 0 || this.localSelected == null) return;

      var currTable = this.getCurrentTable();
      if (currTable == null) {
        return;
      }

      // currTable.updateData([]);

      await this.requestData(this.localSelected);

      currTable.updateData(this.filterData(this.data));
    },
    

    getSimulationNames() {
      var names = [];
      this.$store.state.Simulations.forEach((element) => {
        names.push(element.Simulation_Name);
      });
      return names;
    },

    async requestData(simName) {
      const data = await this.$store.state.networkHandler.getResults(simName);
      if (data == null) {
        clearInterval(this.$store.state.adminPanel.requestUpdateID);
        this.$store.state.adminPanel.requestUpdateID = null;
        return
      }
      data.forEach((element) => {
        if (element.results != null) {
          element.days = parseInt(element.results.currHour) / 8;
          element.date = new Date(element.createdAt).toLocaleTimeString() + " " + new Date(element.createdAt).toDateString();
          element.numResources = Object.values(element.results.currCapacities).reduce((a, b) => a + b, 0);
          element.profit = element.results.projectRevenue - element.results.totalCost;
        }
      });
      this.data = data;
    },
  },
};
</script>

<style scoped>
.selection-container {
  padding-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.base-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.admin-container {
  width: 1260px;
  overflow: auto;
}

.admin-text {
  width: 100%;
  font-size: 2em;
  font-weight: bold;
  text-align: center;
  margin-top: -10px;
  color: #373737;
}
.admin-table {
  width: 100%;
  height: 100%;
  font-size: 3em;
}
::-webkit-scrollbar {
  width: 10px !important;
  height: 10px;
}

.card-container{
  position: absolute;
}
</style>
